import React, { FC } from 'react';
import { ISearchResultVm } from '@yakoffice/publisher-types';
import { Link } from 'react-router-dom';
import { useGetEntityLink } from '../../routes';

interface PropTypes {
  searchResult: ISearchResultVm;
}

export const SearchResultTableRow: FC<PropTypes> = ({ searchResult }) => {

  const getEntityLink = useGetEntityLink();

  const link = getEntityLink({
    gameVersionId: searchResult.gameVersionId,
    categoryId: searchResult.categoryId,
    kindId: searchResult.kindId ?? undefined,
    gameEnvironmentId: searchResult.gameEnvironmentId ?? undefined,
    entityId: searchResult.entityId ?? undefined
  });

  return searchResult.kindId && searchResult.gameEnvironmentId && searchResult.entityId &&
    <tr key={searchResult.entityId.toString()}>
      <td><Link to={link}>{searchResult.entityName}</Link>
      </td>
    </tr>;
};
